import script from "./ComHuonekorttiLiitteetTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekorttiLiitteetTable.vue?vue&type=script&setup=true&lang=ts"

import "./ComHuonekorttiLiitteetTable.vue?vue&type=style&index=0&id=4a993a96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a993a96"]])

export default __exports__